import { useQuery } from '@tanstack/react-query';

import { getEvent } from 'data/events';

const useEvent = (eventId, ooId = null) => {

    const normalizedOoId = ooId ?? null;

    const {
    isLoading,
    data = {},
    error,
    refetch,
    
  } = useQuery(['eventInfo', eventId, normalizedOoId], () => getEvent(eventId, normalizedOoId), {
      enabled: Boolean(eventId),
      refetchOnMount: 'always',
      keepPreviousData: false,
  });

  return {
    isLoading,
    data,
    error,
    refetch,
  };
};

//const useEvent = (eventId, ooId) => {
//    return useQuery(
//        ['eventInfo', eventId, ooId],
//        () => getEvent(eventId, ooId),
//        {
//            enabled: Boolean(eventId && ooId),
//            // optional hardening if you still see stale flashes:
//            refetchOnMount: 'always',
//            keepPreviousData: false,
//            // use these only if you *really* want zero reuse:
//            // staleTime: 0,
//            // cacheTime: 0,
//        }
//    );
//};

export default useEvent;
